import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/app/common";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function PaymentResult() {
  const [sp] = useSearchParams();
  const { refresh } = useAuth();
  const [order, setOrder] = useState(null);
  const tries = useRef(0);
  useEffect(() => {
    const id = sp.get("siparis");
    let t;
    const load = async () => {
      try {
        const { data } = await api.get(`/orders/${id}`);
        setOrder(data);
        if (data.status === "PENDING" && tries.current++ < 20) t = setTimeout(load, 3000);
        else refresh();
      } catch { setOrder(false); }
    };
    load();
    return () => clearTimeout(t);
  }, [sp, refresh]);
  const paid = order?.status === "PAID";
  const pending = order?.status === "PENDING";
  return (
    <div className="grid min-h-screen place-items-center px-4">
      <div className="glass-card w-full max-w-md p-8 text-center animate-fade-up" data-testid="payment-result">
        <div className="flex justify-center"><Logo /></div>
        <div className="mt-8 flex justify-center">
          {pending || order === null ? <Loader2 className="h-14 w-14 animate-spin text-primary" /> : paid ? <CheckCircle2 className="h-14 w-14 text-emerald-500" /> : <XCircle className="h-14 w-14 text-rose-500" />}
        </div>
        <h1 className="mt-5 text-2xl font-bold" data-testid="payment-result-title">
          {pending || order === null ? "Ödemeniz doğrulanıyor..." : paid ? "Ödeme başarılı!" : "Ödeme tamamlanamadı"}
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {paid ? `${order.product_snapshot?.kind === "REGISTRATION" ? "Hesabınız aktif edildi. " : ""}${order.credits} kredi hesabınıza eklendi.` : pending ? "Bu işlem birkaç saniye sürebilir." : "Kartınızdan çekim yapılmadıysa tekrar deneyebilirsiniz."}
        </p>
        <Button asChild className="btn-glow mt-8 w-full rounded-xl" data-testid="payment-result-continue"><Link to="/panel">Panele Git</Link></Button>
      </div>
    </div>
  );
}
